import React from "react";
import {DataTableColumnProps} from "peggirkit";
import {IntlShape} from "react-intl";
import {DeliveryArea} from "@/data/entities/deliveryArea";
import {SetStateFn} from "@/utils/SetStateUtils";
import {DeleteDeliveryAreaState} from "@widgets/deliveryAreas/delete/DeleteDeliveryAreaModal";
import OptionsFormatter from "@widgets/deliveryAreas/overview/table/OptionsFormatter";
import {EditDeliveryAreaState} from "@widgets/deliveryAreas/edit/EditDeliveryAreaModal";
import MoneyFormatter from "@widgets/deliveryAreas/overview/table/MoneyFormatter";

export const getDeliveryAreasTableColumns = (
    intl: IntlShape,
    deleteDeliveryAreaState: SetStateFn<DeleteDeliveryAreaState>,
    editDeliveryAreaState: SetStateFn<EditDeliveryAreaState>,
): DataTableColumnProps<DeliveryArea>[] => ([
    {
        id: "postalCode",
        label: {
            displayName: intl.formatMessage({id: "postalCode"}),
        },
        primary: true,
    },
    {
        id: "deliveryTimeMinutes",
        label: {
            displayName: intl.formatMessage({id: "travelTimeMinutes"}),
        },
        align: "right",
        formatter: deliveryTimeMinutes => intl.formatMessage({id: "nMinutes"}, {n: deliveryTimeMinutes})
    },
    {
        id: "minimumOrderAmount",
        label: {
            displayName: intl.formatMessage({id: "minimumOrderAmount"}),
        },
        align: "right",
        formatter: minimumOrderAmount => <MoneyFormatter amount={minimumOrderAmount}/>,
    },
    {
        id: "deliveryFee",
        label: {
            displayName: intl.formatMessage({id: "deliveryFee"}),
        },
        align: "right",
        formatter: deliveryFee => <MoneyFormatter amount={deliveryFee}/>,
    },
    {
        id: "id",
        label: {
            displayName: intl.formatMessage({id: "edit"}),
            hide: true,
        },
        primary: false,
        sortingConfig: {
            enabled: false,
        },
        align: "right",
        formatter: (_, deliveryArea) => (
            <OptionsFormatter
                deleteDeliveryAreaState={deleteDeliveryAreaState}
                editDeliveryAreaState={editDeliveryAreaState}
                deliveryArea={deliveryArea}
            />
        ),
    },
]);